module.exports = __webpack_public_path__ + "static/img/404.b5e25541.png";